import { Badge } from '@mantine/core';
import { ROZET_RENGI, type RozetAnlami } from '../theme';

/**
 * ROZET (P3 · P3-a · P3-b — Kapsam §20.3b).
 *
 * ⚠️ **BİLEŞEN ANLAM ALIR, RENK ALMAZ.** `<Rozet anlam="engel">` yazılır;
 * ekrana Mantine palet adı (kırmızı/sarı/…) YAZILMAZ. Renk eşlemesi TEK
 * YERDEDİR (`theme.ts` `ROZET_RENGI` → `ANLAM_TABANI`) — ekranda sabitlenen
 * her renk, o eşlemeyi ikinci bir yere böler ve görsel dil turunu tek
 * dosyalık bir işten yüz ekranlık bir işe çevirir.
 *
 * ⚠️ **KIRMIZI = ENGEL *VEYA* KABUL EDİLEMEZ SEVİYE** (P3-a, iki kollu):
 * `engel` anlamı yalnız "sistem seni durduruyor" demez; İSG dilinde riskin
 * ağırlığını da söyler (risk bandı hiçbir kapıyı kapatmadığı hâlde kırmızıdır).
 */
export function Rozet({
  anlam,
  children,
  testId,
}: {
  anlam: RozetAnlami;
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element {
  const { color, variant } = ROZET_RENGI[anlam];
  return (
    <Badge color={color} variant={variant} data-testid={testId} data-anlam={anlam}>
      {children}
    </Badge>
  );
}
